module.exports = __webpack_public_path__ + "static/media/proj18_img2.24406a36.jpg";